import React from 'react';
import { Construction } from 'lucide-react';

export default function ComingSoon({ title, description }) {
  return (
    <div className="p-8 flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
        <Construction className="w-8 h-8 text-slate-400" />
      </div>
      <h2 className="text-xl font-semibold text-slate-700 mb-2">{title}</h2>
      <p className="text-slate-400 max-w-sm">{description || 'Diese Seite wird demnächst verfügbar sein.'}</p>
    </div>
  );
}
